'use client'

import { Button } from '@/ui/shared/components/button'
import { Card, CardContent } from '@/ui/shared/components/card'
import { Search, Home, ArrowLeft } from 'lucide-react'

export const dynamic = 'force-dynamic'

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white">
      <section className="py-24 px-4 relative overflow-hidden min-h-screen flex items-center">
        <div className="absolute inset-0 w-full h-full">
          <div className="absolute top-10 sm:top-20 right-0 w-48 sm:w-64 lg:w-96 h-48 sm:h-64 lg:h-96 bg-gradient-to-br from-purple-200/30 to-pink-200/30 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 sm:bottom-20 left-10 sm:left-20 w-32 sm:w-48 lg:w-64 h-32 sm:h-48 lg:h-64 bg-gradient-to-br from-blue-200/20 to-purple-200/20 rounded-full blur-2xl"></div>
        </div>

        <div className="container mx-auto max-w-4xl relative z-10">
          <Card className="p-8 md:p-12 hover-lift bg-white border-gray-200 shadow-xl">
            <CardContent className="p-0 text-center">
              <div className="w-20 h-20 gradient-primary rounded-2xl flex items-center justify-center mx-auto mb-8 glow-violet">
                <Search className="w-10 h-10 text-white" />
              </div>

              <h1 className="onest-heading-main text-6xl md:text-8xl mb-6 text-gray-900">
                404
              </h1>

              <h2 className="onest-heading-main mb-6 text-gray-900 leading-tight">
                Страница не найдена
              </h2>

              <p className="onest-description text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
                К сожалению, запрашиваемая страница не существует или была перемещена.
              </p>

              <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
                <Button
                  size="lg"
                  variant="primary"
                  onClick={() => window.location.replace('/')}
                  className="text-white px-10 py-6 onest-button"
                >
                  <Home className="w-6 h-6 mr-3" />
                  На главную
                </Button>

                <Button
                  variant="outline"
                  size="lg"
                  onClick={() => window.history.back()}
                  className="px-10 py-6 onest-button border-purple-300 hover:border-purple-600 hover:bg-purple-50 hover-lift bg-white"
                >
                  <ArrowLeft className="w-6 h-6 mr-3" />
                  Назад
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  )
}
